/* fs-pdp-common — scroll reveal + scroll-to-top buttons + accordions + review filters. */
(function () {
  'use strict';

  // Loaded by multiple PDP sections — browser re-executes the file per <script> tag,
  // which would bind every accordion/filter listener N times (click toggles N× = net no-op).
  // Guard so the body runs exactly once per page.
  if (window.__fsPdpCommonInit) return;
  window.__fsPdpCommonInit = true;

  // ---- scroll reveal ----
  var srEls = document.querySelectorAll('.fs-sr,.fs-sr--left,.fs-sr--right,.fs-sr--scale');
  if (srEls.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          e.target.querySelectorAll('[data-bar-fill]').forEach(function (b) { b.classList.add('is-in'); });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    srEls.forEach(function (el) { obs.observe(el); });
  } else {
    srEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  // ---- scroll to top (CTA buttons) ----
  document.querySelectorAll('[data-scroll-top]').forEach(function (btn) {
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  });

  // ---- scroll to selector ----
  document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.querySelector(btn.getAttribute('data-scroll-to'));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ---- accordions (FAQ + ingredient panels). data-accordion on wrapper, .is-open toggles ----
  document.querySelectorAll('[data-accordion]').forEach(function (wrap) {
    var single = wrap.getAttribute('data-accordion') === 'single';
    wrap.querySelectorAll('[data-acc-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-acc-item]');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        if (single) {
          wrap.querySelectorAll('[data-acc-item].is-open').forEach(function (i) { i.classList.remove('is-open'); });
        }
        item.classList.toggle('is-open', !isOpen);
        q.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });

  // ---- generic filter pill groups (review filters, etc) ----
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    group.querySelectorAll('[data-filter]').forEach(function (f) {
      f.addEventListener('click', function () {
        group.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.remove('is-active'); });
        f.classList.add('is-active');
      });
    });
  });

  // ---- Reviews chrome → Judge.me bridge ----
  // Our Figma chrome shows the "Write a Review" box + filter pills + Load More,
  // but JM's own header (with its write-review button) is hidden to avoid a
  // duplicate summary. Wire our controls to JM's (hidden) write-review trigger.
  (function () {
    var jmRoot = document.getElementById('judgeme_product_reviews');
    if (!jmRoot) return;
    function clickJmWrite() {
      var jmWrite = jmRoot.querySelector('.jm-button--primary, .jdgm-write-rev-link');
      if (jmWrite) { jmWrite.click(); }
      jmRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    document.querySelectorAll('.fs-pdp-rv__write-btn, [data-rv-write]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); clickJmWrite(); });
    });
  })();
})();
